
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.125 6.875l2.5-2.5a3.536 3.536 0 015 0v0a3.536 3.536 0 010 5l-2.5 2.5m-6.25-3.75l-2.5 2.5a3.536 3.536 0 000 5v0a3.536 3.536 0 005 0l2.5-2.5M7.5 12.5l5-5","stroke":"#78909C","stroke-width":"2"}})])
          )
        }
      }
    